module.exports = __webpack_public_path__ + "fa1ca72743dfd713774409bff70351c7.svg";